module.exports = __webpack_public_path__ + "img/asset4.47c775e9.png";